export const getters = {
  companies: state => state.companies,
  multipleCompanies: state => state.companies && state.companies.length > 1,
};
